import { useTranslation } from 'react-i18next'

import { Box as DarkBox } from '@hivewatch/dark'

import { DeviceType } from '@/graphql/generated/schemas'

import { ConnectionI } from '../../types/types'
import { getAssociationVisualColors } from '../../utils/floorPlanVisuals'
import { DarkFloorPlanAssociationMarker } from './DarkFloorPlanAssociationMarker'
import { DarkFloorPlanDeviceMarker } from './DarkFloorPlanDeviceMarker'
import { darkPopoverStyles } from './DarkFloorPlanPopover.styles'
import { DarkTailgatePopoverBody } from './DarkTailgatePopoverBody'
import { getTailgatePopoverCopy } from './tailgatePopoverCopy'

interface DarkTailgatePopoverContentIProps {
  colorScheme: 'dark' | 'light'
  deviceName: string
  cameraName: string
  connection: ConnectionI
}

export const DarkTailgatePopoverContent = ({
  colorScheme,
  deviceName,
  cameraName,
  connection,
}: DarkTailgatePopoverContentIProps) => {
  const { t } = useTranslation()
  const s = darkPopoverStyles(colorScheme)
  const { titleKey } = getTailgatePopoverCopy(connection)
  const associationColors = connection
    ? getAssociationVisualColors(connection, colorScheme)
    : null
  const deviceType = connection?.deviceType ?? DeviceType.Door

  return (
    <DarkBox {...s.body} data-testid='DarkTailgatePopoverContent:wrapper'>
      <DarkBox mb='16px'>
        <DarkBox {...s.title}>{t(titleKey)}</DarkBox>
        <DarkTailgatePopoverBody
          colorScheme={colorScheme}
          connection={connection}
        />
      </DarkBox>
      <DarkBox {...s.connectionList}>
        <DarkBox {...s.connectionRow}>
          <DarkFloorPlanDeviceMarker
            colorScheme={colorScheme}
            deviceType={DeviceType.Camera}
          />
          <DarkBox {...s.connectionName}>{cameraName}</DarkBox>
        </DarkBox>
        {connection && associationColors && (
          <>
            <DarkBox {...s.connector} borderColor={associationColors.line} />
            <DarkBox {...s.associationRow}>
              <DarkFloorPlanAssociationMarker
                colorScheme={colorScheme}
                connection={connection}
              />
            </DarkBox>
          </>
        )}
        <DarkBox {...s.connectionRow}>
          <DarkFloorPlanDeviceMarker
            colorScheme={colorScheme}
            deviceType={deviceType}
          />
          <DarkBox {...s.connectionName}>{deviceName}</DarkBox>
        </DarkBox>
      </DarkBox>
    </DarkBox>
  )
}
